var _text, _text2, _text3, _g, _g2, _g3, _line, _g4, _g5, _line2, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNewCeilingToWindow3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "540px",
    height: "650px",
    viewBox: "0 0 540 650",
    enableBackground: "new 0 0 540 650",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 130.6613 18.4605)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 26
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 221.1897 18.4605)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 26
  }, "B")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 311.7866 18.4605)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 26
  }, "C")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 320.6,
    y1: 82.4,
    x2: 320.6,
    y2: 552.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.6,85 320.6,69.5 329.5,85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.6,549.9 320.6,565.5 329.5,549.9  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 229.4,
    y1: 82.4,
    x2: 229.4,
    y2: 552.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.4,85 229.4,69.5 238.3,85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.4,549.9 229.4,565.5 238.3,549.9  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 139.2,
    y1: 82.4,
    x2: 139.2,
    y2: 552.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.2,85 139.2,69.5 148.2,85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.2,549.9 139.2,565.5 148.2,549.9  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 641.6,
    x2: 460,
    y2: 641.6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M477.9,648v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1H477.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M488.7,648v-13.3h1.7v11.9h6.2v1.5H488.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M499.1,644.8c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5s1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9C500.4,646.7,499.6,645.9,499.1,644.8z M500,641.3c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9s1.6,0.7,2.6,0.7 c1,0,1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9s-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 S500,639.7,500,641.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M514.4,644.8c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5s1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9C515.7,646.7,514.9,645.9,514.4,644.8z M515.3,641.3c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9s1.6,0.7,2.6,0.7 c1,0,1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9s-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 S515.3,639.7,515.3,641.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M529.4,648v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.8,1.2c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3H531v5.3H529.4z M531,641.2h3.5 c0.8,0,1.4-0.2,1.9-0.7c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7H531V641.2z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 176.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 199.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 69.5,
    x2: 460,
    y2: 69.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M468.8,71.9c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-1.9,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2s1.3-1.1,2.2-1.4 s1.7-0.5,2.7-0.5c2.1,0,3.8,0.9,5.1,2.6l-1.4,0.8c-0.4-0.6-0.9-1.1-1.6-1.4s-1.4-0.5-2.1-0.5c-1.5,0-2.7,0.5-3.7,1.5 s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8s1.1,1.5,1.8,1.9s1.7,0.7,2.6,0.7c0.7,0,1.4-0.2,2.1-0.5s1.2-0.8,1.6-1.4l1.4,0.8 c-1.3,1.8-3,2.7-5.1,2.7c-1,0-1.8-0.2-2.7-0.5s-1.6-0.8-2.2-1.4S469.2,72.8,468.8,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M482.4,75.8V62.5h8.7v1.5H484v4.3h6.9v1.5H484v4.6h7.1v1.5H482.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M493.8,75.8V62.5h1.7v13.3H493.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M498.3,75.8V62.5h1.7v11.9h6.2v1.5H498.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M508.4,75.8V62.5h1.7v13.3H508.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M513.2,75.8V62.5h1.7l7.7,10.4V62.5h1.7v13.3h-1.6l-7.8-10.6v10.6H513.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M527.3,72c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-2,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.9,0.8,5.2,2.5l-1.3,0.8c-0.4-0.6-1-1-1.7-1.3c-0.7-0.3-1.4-0.5-2.2-0.5c-1.5,0-2.7,0.5-3.7,1.5 c-1,1-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8c0.4,0.8,1.1,1.5,1.8,1.9c0.8,0.5,1.7,0.7,2.6,0.7c0.7,0,1.4-0.1,2.1-0.4 c0.6-0.3,1.2-0.6,1.5-1v-2.7h-4.6v-1.5h6.2v4.8c-0.6,0.7-1.4,1.3-2.3,1.7c-0.9,0.4-1.9,0.6-2.9,0.6c-0.9,0-1.8-0.2-2.7-0.5 c-0.8-0.3-1.6-0.8-2.2-1.4C528.1,73.6,527.7,72.8,527.3,72z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNewCeilingToWindow3);
export default __webpack_public_path__ + "static/media/help_new_ceiling_to_window_3.7a40c596a35d24e8b566c319b9aa5098.svg";
export { ForwardRef as ReactComponent };